import { useEffect, useState } from 'react';
import RModal from '../../../../../components/Rsuite/Modal';
import { CustomButton } from '../../../../../components/CustomButton';
import { daysLabels } from '../../../../../constants/daysLabels';
import { dataDays } from '../../../../../constants/dataDays';
import { Spacer } from '../../../../../components/Spacer';
import { Label } from '../../../../../components/Label';
import { CustomInput } from '../../../../../components/CustomInput';
import { CustomCheckPicker } from '../../../../../components/CustomCheckPicker';
import { useAuth } from '../../../../../hooks/auth';
import { toastSuccess, toastError } from '../../../../../toasts';
import api from '../../../../../services/api';
import { Checkbox, Toggle } from 'rsuite';
import { Field, Row, TitleSchedulePromo } from '../../styles';
import { formatTime } from '../../utils';

const allValue = dataDays.map((item) => item.value);

const EditarCadastrarHorarioPromo = ({
  open,
  handleClose,
  schedule,
  promo,
  onSaved,
}) => {
    const { id_empresa } = useAuth();
    const [selecteds, setSelecteds] = useState([]);
    const [start, setStart] = useState('');
    const [end, setEnd] = useState('');
    const [status, setStatus] = useState(true);
    const [saving, setSaving] = useState(false);

    const handleCheckAll = (_, checked) => {
      setSelecteds(checked ? allValue : []);
    };

    const validateFields = () => {
      if (!schedule && (!Array.isArray(selecteds) || selecteds.length < 1)) {
          throw new Error('Selecione ao menos um dia da semana');
      }

      if (typeof start !== 'string' || start.length < 5) {
          throw new Error('Informe a hora de início');
      }

      if (typeof end !== 'string' || end.length < 5) {
          throw new Error('Informe a hora de término');
      }

      if (formatTime(start) === formatTime(end)) {
          throw new Error('A hora de início e de término não podem ser iguais');
      }
    };

    const createSchedules = async () => {
      const form = selecteds.map((day) => ({
          IdEmpresa: id_empresa,
          IdPromocao: promo.Id,
          Dia: day,
          Inicio: start,
          Fim: end,
      }));

      const result = await api.post(`horarios-promocao/criar`, form);
      onSaved?.(result.data);
      toastSuccess(form.length > 1 ? 'Horários salvos' : 'Horário salvo');
    };

    const editSchedule = async () => {
      const form = {
        Inicio: start,
        Fim: end,
        Ativo: status
      };

      const result = await api.patch(`horarios-promocao/${schedule.Id}`, form);
      onSaved?.([result.data]);
      toastSuccess('Horário atualizado');
    };

    const handleSubmit = async () => {
      try {
        validateFields();
      } catch (error) {
        toastError(error.message);
        return;
      }

      setSaving(true);
      try {
        if (schedule) await editSchedule();
        else await createSchedules();
        handleClose();
      } catch (error) {
        toastError(
          error?.response?.data?.Msg ||
            (schedule ? 'Não foi possível editar o horário' : 'Não foi possível criar os horários'),
        );
      } finally {
        setSaving(false);
      }
    };

    useEffect(() => {
      if (schedule) {
        setStart(formatTime(schedule.Inicio));
        setEnd(formatTime(schedule.Fim));
        setStatus(Boolean(schedule.Ativo));
      }
    }, [open, schedule]);

    return (
      <RModal
        open={open}
        onClose={handleClose}
        title={schedule ? "Editar Horário" : "Cadastrar Horário"}
        footer={
          <>
            <CustomButton appearance="default" onClick={handleClose} disabled={saving}>
              Cancelar
            </CustomButton>
            <CustomButton onClick={handleSubmit} loading={saving} disabled={saving}>
              Salvar
            </CustomButton>
          </>
        }
      >
        {!schedule && (
          <Field>
            <Label>Dia(s)</Label>
            <CustomCheckPicker
              data={dataDays}
              searchable={false}
              placeholder="Ex: Segunda, Terça..."
              value={selecteds}
              onChange={setSelecteds}
              style={{ width: 350 }}
              renderExtraFooter={() => (
                <Checkbox
                  indeterminate={selecteds?.length > 0 && selecteds?.length < allValue.length}
                  checked={selecteds?.length === allValue.length}
                  onChange={handleCheckAll}
                >
                  Selecionar Todos
                </Checkbox>
              )}
            />
          </Field>
        )}

        {schedule && (
          <Field>
            <TitleSchedulePromo>{daysLabels[schedule.Dia]}</TitleSchedulePromo>
          </Field>
        )}

        <Spacer y={10} />
        <Row>
            <Field>
                <Label>Início</Label>
                <CustomInput
                    type="time"
                    value={start}
                    onChange={setStart}
                />
            </Field>
            <Field>
                <Label>Fim</Label>
                <CustomInput
                    type="time"
                    value={end}
                    onChange={setEnd}
                />
            </Field>
        </Row>
        <Spacer y={10} />
        {schedule && <Row>
            <Toggle
                checked={status}
                onChange={() => setStatus(!status)}
                checkedChildren="Ativo"
                unCheckedChildren="Inativo"
            />
        </Row>}
      </RModal>
    )
}

export default EditarCadastrarHorarioPromo;
